import http from '@/util/http'
import { getToken } from '@/util/store';

class FileV2Api {
  //获取pageId
  getPageId(data) {
    let url = "/share-foreign/commannex/getPageId"
    return http.post(url, data);
  }
  //单个附件列表
  listFile(data) {
    let url = '/aaas-file/file/listFile';
    return http.post(url, data);
  }
  //多个附件列表
  listFileMore(data) {
    let url = '/aaas-file/file/listFileMore';
    return http.post(url, data);
  }
  //附件删除-redis
  deleteFileRedis(data) {
    let url = '/aaas-file/file/deleteFileRedis';
    return http.post(url, data);
  }
  //附件业务保存
  businessSaveFile(data) {
    let url = '/aaas-file/file/businessSaveFile';
    return http.post(url, data);
  }

  uploadAnnex(data) {
    let url = '/share-foreign/commannex/uploadAnnex';
    return http.post(url, data);
  }
}

export default FileV2Api
